import { render, staticRenderFns } from "./NewSecondaryUser.vue?vue&type=template&id=6473a9ff&scoped=true&"
import script from "./NewSecondaryUser.vue?vue&type=script&lang=js&"
export * from "./NewSecondaryUser.vue?vue&type=script&lang=js&"
import style0 from "./NewSecondaryUser.vue?vue&type=style&index=0&id=6473a9ff&scoped=true&lang=css&"
import style1 from "./NewSecondaryUser.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473a9ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6473a9ff')) {
      api.createRecord('6473a9ff', component.options)
    } else {
      api.reload('6473a9ff', component.options)
    }
    module.hot.accept("./NewSecondaryUser.vue?vue&type=template&id=6473a9ff&scoped=true&", function () {
      api.rerender('6473a9ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/SecondaryUser/NewSecondaryUser.vue"
export default component.exports